import React from "react";
import { Box, Typography } from "@mui/material";

interface TextIconProps {
  title: string;
  icon: React.ReactNode;
  colorBackground?: string;
  colorIcon?: string;
}

const TextIcon: React.FC<TextIconProps> = ({
  title,
  icon,
  colorBackground = "transparent",
  colorIcon = "inherit",
}) => {
  return (
    <Box display="flex" alignItems="center" gap={2} mb={2}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 42,
          width: 42,
          fontSize: "2em",
          backgroundColor: colorBackground,
          color: colorIcon,
          borderRadius: "50%", 
        }}
      >
        {icon}
      </Box>
      <Typography variant="h6">{title}</Typography>
    </Box>
  );
};

export default TextIcon;
